import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { ClubkarteArtApi } from './PersonClubkarteArtApi';

/**
 * APIL Url: ADAC.Internet.Types.Person.Clubkarte
 * 
 * Endpoints: /api/Identity
 */
export class ClubkarteApi extends BaseApiModel {
	constructor(initialProperties?: Partial<ClubkarteApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected art: ClubkarteArtApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.ClubkarteArt
	 */
	get Art(): ClubkarteArtApi {
		return this.art;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.ClubkarteArt
	 */
	set Art(value: ClubkarteArtApi) {
		this.art = value;
	}

	protected gueltigVon: string;
	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	get GueltigVon(): string {
		return this.gueltigVon;
	}

	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	set GueltigVon(value: string) {
		this.gueltigVon = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): ClubkarteApi {
		return AppUtils.Helper.createFromMap(dataObject, ClubkarteApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Art = this.art;
		result.GueltigVon = this.gueltigVon;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}